//mui
import { styled } from "@mui/material";
import { Spinner } from "@fluentui/react-components";
import { FAIcon } from "./FAIcon";

const LoadingWrapper = styled("div")(() => ({
  width: "100vw",
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  fontFamily: "Public Sans",
  "& svg > circle:first-of-type": {
    opacity: 0,
  },
}));

const Error = styled("p")({
  maxWidth: 400,
  marginTop: 24,
  textAlign: "center",
  fontWeight: 600,
});

const Icon = styled(FAIcon)({
  fontSize: 60,
  opacity: 0.5,
  marginLeft: 10
});

export const Loading = ({ error, status = "" }) => {
  return (
    <LoadingWrapper>
      {!error && <Spinner size="medium" label={status} />}
      {error && (
        <>
          <Icon value="fa-solid fa-user-magnifying-glass" />
          <Error>{error}</Error>
        </>
      )}
    </LoadingWrapper>
  );
};
